import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Utility function to conditionally merge CSS class names.
 * Combines clsx for conditional classes with tailwind-merge to resolve conflicts.
 * @param inputs - Array of class values (strings, objects, arrays)
 * @returns Merged and deduplicated CSS class string
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
